export const SAVE_SHIPPING_DETAILS = "SAVE_SHIPPING_DETAILS"

export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST"
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS"
export const CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL"
export const CREATE_ORDER_CLEAR = "CREATE_ORDER_CLEAR"

export const GET_ORDER_REQUEST = "GET_ORDER_REQUEST"
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS"
export const GET_ORDER_FAIL = "GET_ORDER_FAIL"
export const GET_ORDER_CLEAR = "GET_ORDER_CLEAR"

export const MARK_PAID_REQUEST = "MARK_PAID_REQUEST"
export const MARK_PAID_SUCCESS = "MARK_PAID_SUCCESS"
export const MARK_PAID_FAIL = "MARK_PAID_FAIL"
export const MARK_PAID_CLEAR = "MARK_PAID_CLEAR"

export const MARK_DELIVERED_REQUEST = "MARK_DELIVERED_REQUEST"
export const MARK_DELIVERED_SUCCESS = "MARK_DELIVERED_SUCCESS"
export const MARK_DELIVERED_FAIL = "MARK_DELIVERED_FAIL"
export const MARK_DELIVERED_CLEAR = "MARK_DELIVERED_CLEAR"

export const GET_ALL_ORDERS_REQUEST = "GET_ALL_ORDERS_REQUEST"
export const GET_ALL_ORDERS_SUCCESS = "GET_ALL_ORDERS_SUCCESS"
export const GET_ALL_ORDERS_FAIL = "GET_ALL_ORDERS_FAIL"
export const GET_ALL_ORDERS_CLEAR = "GET_ALL_ORDERS_CLEAR"
